import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  LOCALE_ID,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";
import { Layout, Notification, Spinner } from "pax-ui/components";
import { LanguageSelectOption } from "projects/pax-ui/components/uncontrolled-select/types/language-select-option.interface";

import { BackgroundSubscriptionNavigationService } from "./shared/services/background-subscription-navigation.service";
import { makeLanguageSelectOptions } from "./shared/services/language/language-select-options";
import { Language } from "./shared/services/language/language.enum";
import { LanguageService } from "./shared/services/language/language.service";
import { BackgroundSubscriptionNotificationPublisherService } from "./shared/services/notification/background-subscription-notification-publisher.service";
import { AppState } from "./shared/store/app.state";
import * as NotificationActions from "./shared/store/notification/notification.actions";
import * as NotificationSelectors from "./shared/store/notification/notification.selectors";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterModule, Layout, Spinner, Notification],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly acceptedLanguages: LanguageSelectOption[] =
    makeLanguageSelectOptions();
  readonly initialLanguage = this.acceptedLanguages.find(
    (language) => language.value === this._languageService.getLanguage(),
  );

  readonly notificationMessages$ = this._store.select(
    NotificationSelectors.selectNotificationMessages,
  );

  constructor(
    public readonly backgroundSubscriptionNavigationService: BackgroundSubscriptionNavigationService,
    private readonly _backgroundSubscriptionNotificationPublisherService: BackgroundSubscriptionNotificationPublisherService,
    private readonly _languageService: LanguageService,
    private readonly _store: Store<AppState>,
    @Inject(LOCALE_ID) public readonly locale: string,
  ) {
    this.startGlobalSubscriptions();
  }

  setLanguage(selectedLanguage: Language) {
    this._languageService.setLanguage(selectedLanguage);
  }

  deleteNotificationMessage(notificationMessageId: number) {
    this._store.dispatch(
      NotificationActions.tryDeleteNotification({
        notificationId: notificationMessageId,
      }),
    );
  }

  private startGlobalSubscriptions() {
    this.backgroundSubscriptionNavigationService.start();
    this._backgroundSubscriptionNotificationPublisherService.start();
  }
}
